import { PLAN_CHART_SERIES_COLORS } from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';

/**
 * Colours a user can give an action. The list API has no colour field yet, so the choice is kept
 * in the browser (keyed by action id) and read back by the Actions bar; once the backend stores
 * `action.color` the bar already prefers it and this file only needs to stop writing.
 */
export const ACTION_COLOR_OPTIONS: readonly string[] = PLAN_CHART_SERIES_COLORS;

const STORAGE_KEY = 'blox.data.actionColors';

const readAll = (): Record<string, string> => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') ?? {};
  } catch {
    return {};
  }
};

export const getStoredActionColor = (actionId: number | string | null | undefined) =>
  actionId === null || actionId === undefined ? undefined : readAll()[String(actionId)];

export const setStoredActionColor = (actionId: number | string, color: string) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readAll(), [String(actionId)]: color }));
  } catch {
    // Storage can be unavailable (private mode, quota) — the auto colour is an acceptable fallback.
  }
};

/** Colour used when nothing was chosen: stable per id so it does not change between reloads. */
export const getFallbackActionColor = (actionId: number | string | null | undefined) =>
  ACTION_COLOR_OPTIONS[Math.abs(Number(actionId) || 0) % ACTION_COLOR_OPTIONS.length];

export const resolveActionColor = (action: any): string =>
  action?.color ?? getStoredActionColor(action?.id) ?? getFallbackActionColor(action?.id);
